import React from "react";
import OpenAI from "../openai.png";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1>Check Out Some of My Works.</h1>
          <section id="projects">
            <div className="user-projects flex-row">
              <div className="images-left">
                <a href="https://aicruit.co/" target="_blank">
                  <div className="project-imageLeft">
                    <img
                      alt="AIcruit"
                      src="images/portfolio/AIcruit_Landing.png"
                    />
                    <div className="overlay">
                      <i className="fa fa-link"></i>
                    </div>
                  </div>
                </a>
              </div>
              <div className="contents-right">
                <h3 className="text-white">AIcruit</h3>
                <div className="flex flex-row justify-around items-center gap-4">
                  <img
                    src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                    alt="React"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/python/python-icon.svg"
                    alt="python"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/palletsprojects_flask/palletsprojects_flask-icon.svg"
                    alt="flask"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/js_redux/js_redux-icon.svg"
                    alt="Redux"
                    width="28"
                    height="28"
                  />
                  <img src={OpenAI} alt="OpenAI" width="32" height="32" />
                  <img
                    src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                    alt="Firebase"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/stripe/stripe-icon.svg"
                    width="28"
                    height="28"
                    alt="Stripe"
                  />
                  &nbsp;
                </div>
                <p>
                  Developed a web application that asks people coding interview
                  questions. Deployed a robust Python backend API that handles
                  intensive processes using a constrained a GPT-4-based AI
                  algorithm to score conduct interviews based on a robust
                  rubric.
                </p>
                <a
                  className="project-link"
                  href="https://aicruit.co/"
                  target="_blank"
                >
                  Check it out!
                </a>
              </div>
            </div>
            <div className="user-projects flex-row-reverse">
              <div className="images-left">
                <a href="https://github.com/Srikark-17/Hygeia/" target="_blank">
                  <div
                    className="project-imageLeft"
                    style={{ maxWidth: "400px" }}
                  >
                    <img
                      alt="Hygeia"
                      src="images/portfolio/Hygeia.png"
                      className="w-full h-auto object-contain"
                      style={{ height: "300" + "px" }}
                    />
                    <div className="overlay">
                      <i className="fa fa-link"></i>
                    </div>
                  </div>
                </a>
              </div>
              <div className="contents-right">
                <h3 className="text-white">Hygeia</h3>
                <div className="flex flex-row justify-around items-center gap-4">
                  <img
                    src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                    alt="React"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/python/python-icon.svg"
                    alt="python"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/palletsprojects_flask/palletsprojects_flask-icon.svg"
                    alt="flask"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg"
                    alt="Tensorflow"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                    alt="Firebase"
                    width="32"
                    height="32"
                  />
                  <img
                    src="https://www.vectorlogo.zone/logos/stripe/stripe-icon.svg"
                    width="28"
                    height="28"
                    alt="Stripe"
                  />
                  &nbsp;
                </div>
                <p>
                  Aids physicians by providing diagnoses based on
                  histopathological images. 99.64% accuracy in diagnosing and
                  classifying colorectal cancer. Provides secure and remote
                  access to monitor patients.
                </p>
                <a
                  className="project-link"
                  href="https://github.com/Srikark-17/Hygeia/"
                  target="_blank"
                >
                  Check it out!
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
